module.exports = __webpack_public_path__ + "images/401d815dc206b8dc1b17cd0e37695975.png";